

export interface AuditTableInterface {
  date: Date,
  shift: string,
  components: string[],
  ticket: string,
  time: number,
}

export interface AuditInterface {
  id: number,
  componentIds: number[],
  components: {name: string, id: number, status: string}[],
  shift: string,
  date: string,
  ticket: string,
  time: number,
}

export interface ComponentInterface {
  id?: number,
  name: string,
  status: ComponentStatus,
}

export enum ShiftType {
  WORK = 'WORK',
  PAID = 'PAID',
  UNPAID = 'UNPAID',
  SICK = 'SICK',
  ADDITIONAL_PAID = 'ADDITIONAL_PAID',
  MARRIAGE = 'MARRIAGE',
  BLOOD_DONATION = 'BLOOD_DONATION',
  FUNERAL = 'FUNERAL',
  PATERNITY = 'PATERNITY',
  OTHER = 'OTHER',
}
export enum ComponentStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
}
export default interface DevScrumRepositoryInterface {
  getAuditsByUser(userId: string): Promise<AuditTableInterface[]>;
  getAllComponents(): Promise<ComponentInterface[]>
}


